var scope_0 = require('C:/Users/Great Moustache/openlegendrpg.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bd059baaa44ed8782c4775a4239a54c0.js').default;
var scope_1 = require('C:/Users/Great Moustache/openlegendrpg.com/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    